export const en = {
    break_in_chat: 'Join chat',
    chat: 'Chat Support',
};
